import React from 'react';
import cx from 'classnames';
import css from './reset-all-button.module.scss';

interface IResetAllButtonProps {
	onClick: () => void;
	hasSelectedTags: boolean;
}

export const ResetAllButton = ({ onClick, hasSelectedTags }: IResetAllButtonProps) => (
	<div
		className={cx(css.reset_all, { [css.focus]: hasSelectedTags })}
		role="presentation"
		onClick={onClick}
	>
		Сбросить все
	</div>
);
